// Globals
import { useEffect } from 'react';

// Store
import { useAppDispatch, useAppState } from '@/store';
import {
  getGoogleMerchantSettings,
  selectGoogleMerchantSettings,
  selectGoogleMerchantSettingsError,
  selectGoogleMerchantSettingsIsLoading,
} from '../feature';

export const useGetGoogleMerchantSettings = (channelId?: number) => {
  const merchantSettings = useAppState(selectGoogleMerchantSettings);
  const isLoading = useAppState(selectGoogleMerchantSettingsIsLoading);
  const error = useAppState(selectGoogleMerchantSettingsError);

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!channelId) return;
    dispatch(getGoogleMerchantSettings({ channelId }));
  }, [channelId, dispatch]);

  return {
    merchantSettings,
    isLoading,
    error,
  };
};
